(function () {
  function initCompare(section) {
    const scroll = section.querySelector('.pf-compare__scroll');
    const thumb = section.querySelector('.pf-compare__scrollbar-thumb');
    const track = section.querySelector('.pf-compare__scrollbar');
    if (!scroll || !thumb || !track) return;

    function update() {
      const max = scroll.scrollWidth - scroll.clientWidth;
      if (max <= 1) {
        track.style.display = 'none';
        return;
      }
      track.style.display = '';
      const progress = scroll.scrollLeft / max;
      const travel = track.clientWidth - thumb.offsetWidth;
      thumb.style.transform = 'translateX(' + progress * travel + 'px)';
    }

    scroll.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('.pf-compare').forEach(initCompare);

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.pf-compare');
    if (section) initCompare(section);
  });
})();
